import {Component, OnInit, inject, DestroyRef} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { BlueprintsService } from 'src/app/services/api/blueprints.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { ErrorPageService } from 'src/app/services/util/error-page.service';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import {combineLatest} from 'rxjs';
import {tap} from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Instance } from 'src/app/models/instance/instance';
import { Blueprint, BlueprintTypes } from 'src/app/models/blueprints/blueprint';
import {translate} from '@jsverse/transloco';
import { CapabilitiesGroup, Capability, CapabilityType } from 'src/app/models/service/capability';
import { Solution } from 'src/app/models/service/solution';
import { SolutionVersion } from 'src/app/models/service/solution-version';
import { BreadcrumbItem } from 'src/app/models/breadcrumb/breadcrumb-item';
import { RouterSegments } from 'src/app/models/router-segments';
import { Permission } from 'src/app/models/principal/permission';
import { ToastrService } from 'ngx-toastr';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
// import {CreateSandboxDialogComponent} from '../create-sandbox-dialog/create-sandbox-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { DataZone } from 'src/app/models/data-zone/data-zone';
import { DeploymentClass } from 'src/app/models/instance-class';
import { Deployment } from 'src/app/models/deploy/deployment';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { InstancesService } from 'src/app/services/api/instances.service';
import { TrialStatusService } from 'src/app/services/util/trial-status.service';
import { Title } from '@angular/platform-browser';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';
import { AdditionalCapabilityComponent } from 'src/app/components/additional-capability/additional-capability.component';
import { ComponentType } from 'src/app/models/service/component-type';
import { Constants } from 'src/app/models/constants';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

const REQUIRED_PERMISSIONS = [
  Permission.CREATE_SANDBOX,
  Permission.CREATE_SERVICE_DEFINITION,
  Permission.VIEW_ENTERPRISE,
];

@Component({
    selector: 'app-service-definition-version',
    templateUrl: './service-definition-version.component.html',
    styleUrls: ['./service-definition-version.component.scss'],
    standalone: false
})
export class ServiceDefinitionVersionComponent  implements OnInit {
private destroyRef = inject(DestroyRef);
  dataLoaded = false;
  Constants = Constants;
  service: Solution;
  servicesVersionsMap = new Map<string, SolutionVersion[]>();
  capabilitiesGroups: CapabilitiesGroup[];
  CapabilityType = CapabilityType;
  ComponentType = ComponentType;
  selectedCapabilitiesArr = [];
  demoInstance: Instance;
  blueprint: Blueprint;
  isDemoBlueprint: any;
  blueprintLatestVersion: any;
  UpdateExtendService: boolean;
  UpdateExtendServiceDisable: boolean;
  selectedCapabilitiesLength = [];
  blueprints: Blueprint[];
  instances: Instance[];
  RouterSegments = RouterSegments;
  tenant: string;
  breadcrumbItems: BreadcrumbItem[];
  permissionsMap: { [key: string]: boolean };
  capabilities: any;
  selectedCapabilities: any[];
  displayStartFreeTrialButton: boolean;
  latestSolutionVersionId: any;
  serviceId: any;
  capabilityDescription: Capability[];
  sandboxLoader = false;
  instanceId: string;
  blueprintId: any;
  trialStatus: string;
  instanceStatus: DeployStatus;
  descriptionArray: any;
  errorMessage: any;
  blueprintData: any;
  solutionVersion: any;
  isLoading = true;
  mainArray: any;
  additionalIncluded = [];
  additionalOptional = [];
  selectedCapability = [];
  additionalExchange = [];
  capabilitiesPage = true;
  exchangeAdapters: any;
  selectedExchangeAdapters = [];
  additionalExchangeAdapters = [];
  previousSelection = JSON.parse(localStorage.getItem('selectedCapabilitiesExtend'));
  getSelectedVersions = JSON.parse(localStorage.getItem('selectedVersionExtend'));
  previousSelectionBlueprintId = localStorage.getItem('blueprintExtend');
  showLoader = false;
  versionData = [];
  versionsList = [];
  searchValue: any;
  solutionVersionForm: FormGroup;
  versionSelected = false;
  selectedVersionExtend: any;

  readonly statusInfo: { [key: string]: any } = {
    [DeployStatus.DEPLOYED]: {icon: 'done', colorClass: 'green-1-bg'},
    [DeployStatus.DEPLOYING]: {icon: 'change_circle', colorClass: 'accent-1-bg'},
    [DeployStatus.OPERATION_INPROGRESS]: {icon: 'change_circle', colorClass: 'accent-1-bg'},
    [DeployStatus.FAILED]: {icon: 'close', colorClass: 'warn-solid-bg'},
    [DeployStatus.TERMINATING]: {icon: 'change_circle', colorClass: 'accent-1-bg'},
    [DeployStatus.TERMINATION_FAILED]: {icon: 'error_outline', colorClass: 'warn-solid-bg'},
    [DeployStatus.NOT_DEPLOYED]: {icon: 'close', colorClass: 'neutral-blue-6-bg'},
    [DeployStatus.UPDATED]: {icon: 'done', colorClass: 'green-1-bg'},
    [DeployStatus.UPDATE_FAILED]: {icon: 'close', colorClass: 'warn-solid-bg'}
  };

  readonly INSTANCE_FILTERED_STATES = [DeployStatus.INITIALIZED, DeployStatus.INITIALIZE_FAILED, DeployStatus.INITIALIZING, DeployStatus.DEPLOYED, DeployStatus.FAILED, DeployStatus.DEPLOYING,
    DeployStatus.CONFIGURING, DeployStatus.CONFIGURATION_FAILED, DeployStatus.CONFIGURED, DeployStatus.TESTED, DeployStatus.UPDATED,
    DeployStatus.UPDATE_FAILED, DeployStatus.TEST_FAILED, DeployStatus.FAILOVER_APPLYING, DeployStatus.FAILBACK_APPLYING,
    DeployStatus.PRE_FAILBACK_APPLYING, DeployStatus.FAILOVER_FAILED, DeployStatus.FAILBACK_FAILED, DeployStatus.PRE_FAILBACK_FAILED, DeployStatus.POST_FAILBACK_APPLYING, DeployStatus.POST_FAILBACK_FAILED];
  DeployStatus = DeployStatus;
  createdCapabilities = [];
  createdExchangeCapabilities = [];
  solution: Solution;
  latestSolutionVersion: any;
  includedCapabilities: any;
  optionalCapabilities: any;
  instanceSolutionVersion: string;
  releaseVersion: string;
  allInstances: any;
  sortedSolutionVersionId: any;
  removeExchangeTab = false;
  showMissingMsg: boolean;
  isVersionAvailable = true;
  missingCapabilities: any;
  isDataLoaded: any;
  hasVersionBeenSelected: any;
  selectedBuildVersion: any;
  lastSolutionVersionId: any;
  capabilitiesGroupsMandatory: any;

  constructor(
    private matDialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private toastrService: CustomToastrService,
    private solutionsService: SolutionsService,
    private blueprintsService: BlueprintsService,
    private authService: AuthService,
    private errorPageService: ErrorPageService,
    private permissionsService: PermissionsService,
    private instancesService: InstancesService,
    private trialStatusService: TrialStatusService,
    private readonly titleService: Title,
    private formBuilder: FormBuilder
  ) {
    
  }

  ngOnInit(): void {

    const formConfig: any = {
      buildVersion: [undefined, [Validators.required]],
      searchValue: [''],
    };
    this.solutionVersionForm = this.formBuilder.group(formConfig);
    
    if (history.state.data === ComponentType.EXCHANGE) {
      this.capabilitiesPage = false;
    }
    this.tenant = this.activatedRoute.snapshot.params.id;
    this.blueprintId = this.activatedRoute.snapshot.params.blueprintId;
    const serviceId = this.activatedRoute.snapshot.params.solutionId;
    this.blueprintsService.getBlueprintVersion(this.blueprintId).subscribe(data=>{
      this.blueprintData = data[0]?.runningSolutionVersionId;
    });
    this.solutionsService.getSolutionVersions(serviceId).subscribe(data => {

    if (data) {
      data.forEach(element => {
        this.versionData.push(element);
      });

      let versions = [];
      let arr = [];
      data.forEach(element => {
        arr.push(element.version);
      });
      arr = arr.map( a => a.split('.').map( n => +n+100000 ).join('.') ).sort()
        .map( a => { const parts = a.split('.').map( n => +n-100000)
        const major = parts[0];
        const minor = parts[1] ? parts[1].toString().padStart(2, '0') : '00';
        const patch = parts[2] ? parts[2].toString().padStart(2, '0') : '00';
        return `${major}.${minor}.${patch}`;
      });
      arr?.forEach(item => {
        this.versionData.forEach(data => {
          const major = data.version?.split('.')[0];
          const minor = data.version?.split('.')[1] ? data.version.split('.')[1]?.toString().padStart(2, '0') : '00';
          const patch = data.version?.split('.')[2] ? data.version.split('.')[2]?.toString().padStart(2, '0') : '00';
          data.patchVersion = major + '.' + minor + '.' + patch;
          if(data.patchVersion === item) {
          versions = [...versions, data];
        }})
      })
      this.versionData = this.versionData.map(item => item);

      if (data?.status === 'update_failed') {
        versions.push(data);
      }
      if (versions?.length) {
        this.versionGroup(versions);
      }
    }
    if(this.versionData.length === 0) {
      const noRelease = 'Release not Available';
      this.isVersionAvailable = false;
      this.versionData.push(noRelease);
    }
    
      this.sortedSolutionVersionId = (data?.sort((a,b) => a?.version && b?.version ? b?.version?.localeCompare(a?.version) : !b?.version ? -1 : 1));
      this.getSolutionById(this.activatedRoute.snapshot.params.solutionId);
    })
    combineLatest([this.solutionsService.getSolutionDetailsById(serviceId),
      this.solutionsService.getSolutionVersions(serviceId),
      this.blueprintsService.getBlueprintVersion(this.blueprintId)
    ])
      .pipe(
        tap(([service, serviceVersions]) => {
          const findVersion =  serviceVersions.find(item => item.id === service.latestSolutionVersionId);
          // this.loadCapabilitiesDescription(serviceId, service.latestSolutionVersionId);
          this.service = service;
          this.capabilities = findVersion.capabilities;
          if (this.capabilities?.length > 0) {
            this.capabilities.reduce((acc, capability) => {
              if (capability.required !== CapabilityType.OPTIONAL) {
                capability.selected = true;
              }
              return acc;
            }, {});
          }
          this.servicesVersionsMap.set(this.service.id, serviceVersions);
          this.configureBreadcrumb(service);
          this.titleService.setTitle(this.service?.name);
          // this.loadBlueprint();
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => {
        this.dataLoaded = true;
      }, error => {
        // this.errorPageService.show404Page();
      });
      const blueprintId = this.activatedRoute.snapshot.params.blueprintId;
      this.blueprintsService.getBlueprint(blueprintId)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(blueprint => {
              this.isLoading = false;
              this.blueprint = blueprint;
              this.configureBreadcrumb(this.service);
              this.isDemoBlueprint = blueprint.demo;
              if (this.isDemoBlueprint) {
                // this.loadInstances();
              }
            });
    this.getSolutionById(this.activatedRoute.snapshot.params.solutionId);
  }

  loadData(version?): void {
    this.releaseVersion = version.releaseVersion;
    const blueprintId = this.activatedRoute.snapshot.params.blueprintId;
    const serviceId = this.activatedRoute.snapshot.params.solutionId;
    const tenant = this.activatedRoute.snapshot.params.id;
        this.instancesService.getInstancesForBlueprint(blueprintId, tenant)
    .pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (data: any) => {
        if(data?.data?.length > 0) {
        const filteredInstances = data.data.filter(item => this.INSTANCE_FILTERED_STATES.includes(item.status));
      this.instanceSolutionVersion;
      this.instanceSolutionVersion = (filteredInstances?.find(instances => instances.deploymentClass === DeploymentClass.A)) ? (filteredInstances?.find(instances => instances.deploymentClass === DeploymentClass.A).solutionVersionId)
      : (filteredInstances?.find(instances => instances.deploymentClass === DeploymentClass.B)) ? (filteredInstances.filter(i => i.deploymentClass === DeploymentClass.B)[filteredInstances.filter(i => i.deploymentClass === DeploymentClass.B).length -1].solutionVersionId)
      : (filteredInstances?.find(instances => instances.deploymentClass === DeploymentClass.C)) ? (filteredInstances.filter(i => i.deploymentClass === DeploymentClass.C)[filteredInstances.filter(i => i.deploymentClass === DeploymentClass.C).length -1].solutionVersionId)
      : (filteredInstances?.find(instances => instances.deploymentClass === DeploymentClass.D)) ? (filteredInstances.filter(i => i.deploymentClass === DeploymentClass.D)[filteredInstances.filter(i => i.deploymentClass === DeploymentClass.D).length -1].solutionVersionId)  : this.sortedSolutionVersionId?.id;
        }
      });
        
    this.blueprintsService.getBlueprintVersion(blueprintId).subscribe(data=>{
      this.blueprintData = data[0]?.runningSolutionVersionId;
    });
    combineLatest([this.solutionsService.getSolutionDetailsById(serviceId),
      this.solutionsService.getSolutionVersions(serviceId),
      this.blueprintsService.getBlueprintVersion(blueprintId)
    ])
      .pipe(
        tap(([service, serviceVersions]) => {
          let findVersion;
          if(version) {
            findVersion =  serviceVersions.find(item => item.id === version.id);
          } else {
            if(!this.instanceSolutionVersion || this.instanceSolutionVersion === 'undefined') {
              findVersion =  serviceVersions.find(item => item.id === service.latestSolutionVersionId);
            } else {
              findVersion =  serviceVersions.find(item => item.id === this.instanceSolutionVersion);
            }
          }
          this.loadCapabilitiesDescription(serviceId, (this.instanceSolutionVersion === 'undefined') ? service.latestSolutionVersionId : this.instanceSolutionVersion);
          this.service = service;
          this.capabilities = findVersion.capabilities;
          this.mainArray = findVersion.capabilities;
            let additionalCapabilties = [];
            if(this.previousSelectionBlueprintId === this.activatedRoute.snapshot.params.blueprintId) {
              this.previousSelection?.forEach(item => {
                if (item.nestedObj) {
                  const additional = item?.nestedObj?.filter(data => data.selected === true);
                  additionalCapabilties = [...additionalCapabilties, ...additional];
                }
              });
              additionalCapabilties.forEach(item => {
                if (!this.previousSelection?.find(element => (element.name === item.name) && (item.selected === true))) {
                  this.previousSelection = [...this.previousSelection, item];
                }
              })
              this.mainArray.forEach(item => {
                if (this.previousSelection?.find(element => element.name === item.name)) {
                  item.selected = true;
                  if (item.nested) {
                    item.showAdditional = true;
                  }
                }
              })
            }

            findVersion?.capabilities?.forEach(element => {
              if(element?.nested) {
                element.hasNested = true;
                element?.nested.forEach(data => {
                  this.mainArray = this.mainArray.filter(item => item?.name !== data);
                });
              }
            });
            this.mainArray.forEach(element => {
              let nestedObj = [];
              let obj = {};
              if(element?.nested) {
                element?.nested.forEach(innerElement=> {
                  if (findVersion?.capabilities?.find(item => item.name === innerElement)) {
                    obj = findVersion?.capabilities?.find(item => item.name === innerElement);
                  } else {
                    obj = {
                      name: innerElement
                    }
                  }
                  nestedObj = [...nestedObj, obj];
                });
                element.nestedObj = nestedObj;
                element.selectedNestedObj = element.nestedObj.filter(item => item.selected);
              }
            });
          this.capabilities = this.mainArray;
          if (this.capabilities?.length > 0) {
            this.capabilities.reduce((acc, capability) => {
              if (capability.required !== CapabilityType.OPTIONAL) {
                capability.selected = true;
              }
              return acc;
            }, {});
          }
          const mainArray = this.mainArray;
          if (this.mainArray?.find(item => item.componentType)) {
            this.exchangeAdapters = mainArray.filter(item => item.componentType === ComponentType.EXCHANGE) || [];
            this.mainArray = mainArray.filter(item => item.componentType === ComponentType.TBC || item.componentType === ComponentType.TC);
          } else {
            this.exchangeAdapters = mainArray.filter(item => item.componentType === ComponentType.EXCHANGE) || [];
          }
          if (this.exchangeAdapters?.length === 0) {
            this.removeExchangeTab = true;
            this.capabilitiesPage = true;
          }
          this.includedCapabilities = this.mainArray?.filter(item => item?.required === CapabilityType.MANDATORY);
          this.optionalCapabilities = this.mainArray?.filter(item => item?.required === CapabilityType.OPTIONAL);
          if (!this.mainArray || this.mainArray?.length === 0) {
            this.includedCapabilities = [];
            this.optionalCapabilities = [];
          }
          this.servicesVersionsMap.set(this.service.id, serviceVersions);
          this.titleService.setTitle(this.service?.name);
          this.loadBlueprint(version);
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => {
        this.dataLoaded = true;
      }, error => {
        this.errorPageService.show404Page();
      });   
  }

  loadCapabilitiesDescription(serviceId, latestSolutionVersionId): Promise<any> {
    return new Promise((resolve) => {
      this.solutionsService.getSolutionVersion(serviceId, latestSolutionVersionId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(serviceDetails => {
        this.releaseVersion = serviceDetails?.releaseVersion;
        this.solutionVersion = serviceDetails;
        this.capabilityDescription = serviceDetails.capabilities;
          resolve(serviceDetails.capabilities);
        }, (error) => {
        resolve(error);
      });
    });
  }

  getSelectedCapabilities(): any[] {
    const selectedCapabilities = [];
    const selectedCapabilitiesByName = [];
    if (this.capabilities && this.capabilities.length > 0) {
      this.capabilitiesGroups.forEach(item => {
      item.capabilities.filter((x) => {
        if (x.selected) {
          selectedCapabilities.push(x);
          selectedCapabilitiesByName.push(x.name);
        }
      });
    })
    }
    localStorage.setItem('selectedCapabilitiesExtend', JSON.stringify(selectedCapabilities));
    localStorage.setItem('selectedVersionExtend', JSON.stringify(this.selectedVersionExtend));
    localStorage.setItem('blueprintExtend',  this.activatedRoute.snapshot.params.blueprintId ? this.activatedRoute.snapshot.params.blueprintId : '');
    return selectedCapabilitiesByName;
  }

  updateService(): void {
    this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT, this.activatedRoute.snapshot.params.id, RouterSegments.SERVICE_DEFINITION, RouterSegments.SOLUTION, this.activatedRoute.snapshot.params.solutionId, this.service.latestSolutionVersionId, RouterSegments.DEFINITION, RouterSegments.EXTEND, this.activatedRoute.snapshot.params.blueprintId
    ], {state: {data: this.getSelectedCapabilities(), data1: 'extend'}});
  }

  onClick(component) : void {
    this.matDialog.open(AdditionalCapabilityComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: component.displayName ? component.displayName : component.name,
        component: component,
        confirmButtonText: translate('BUTTONS.SUBMIT')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(result => {
        if (result) {
          if (result.componentType === ComponentType.EXCHANGE) {
            const index = this.exchangeAdapters.findIndex(item => item.name === result.name);
            this.exchangeAdapters[index] = result;
            result?.nestedObj?.forEach(item => {
              this.additionalExchangeAdapters = this.additionalExchangeAdapters.filter(data => data.name !== item.name)
              })
            const selected = result?.nestedObj?.filter(item => item?.selected === true);
            this.additionalExchangeAdapters = [...this.additionalExchangeAdapters, ...selected];
            result.selectedNestedObj = result.nestedObj.filter(item => item.selected);
            this.capabilitiesGroups.forEach(item => {
              item.capabilities.forEach((data: any) => {
                if(data.name === result.name) {
                  data.nestedObj = result.nestedObj;
                  data.selectedNestedObj = result.selectedNestedObj;
                }
              })
            })
          } else if (result.required === CapabilityType.MANDATORY) {
            const index = this.includedCapabilities.findIndex(item => item.name === result.name);
            this.includedCapabilities[index] = result;
            result?.nestedObj?.forEach(item => {
              this.additionalIncluded = this.additionalIncluded.filter(data => data.name !== item.name)
              })
            const selected = result?.nestedObj?.filter(item => item?.selected === true);
            this.additionalIncluded = [...this.additionalIncluded, ...selected];
            result.selectedNestedObj = result.nestedObj.filter(item => item.selected);
            this.capabilitiesGroups.forEach(item => {
              item.capabilities.forEach((data: any) => {
                if(data.name === result.name) {
                  data.nestedObj = result.nestedObj;
                  data.selectedNestedObj = result.selectedNestedObj;
                }
              })
            })
          } else if(result.required === CapabilityType.OPTIONAL) {
            const index = this.optionalCapabilities.findIndex(item => item.name === result.name);
            this.optionalCapabilities[index] = result;
            result?.nestedObj?.forEach(item => {
              this.additionalOptional = this.additionalOptional.filter(data => data.name !== item.name)
              })
            const selected = result?.nestedObj?.filter(item => item?.selected === true);
            this.additionalOptional = [...this.additionalOptional, ...selected];
            result.selectedNestedObj = result.nestedObj.filter(item => item.selected);
            this.capabilitiesGroups.forEach(item => {
              item.capabilities.forEach((data: any) => {
                if(data.name === result.name) {
                  data.nestedObj = result.nestedObj;
                  data.selectedNestedObj = result.selectedNestedObj;
                }
              })
            })
          }
          this.selectedCapability = this.optionalCapabilities?.filter(item => item?.selected === true);
          this.selectedExchangeAdapters = this.exchangeAdapters?.filter(item => item?.selected === true);
        }
      });
  }

  loadBlueprint(version?): void {
    const blueprintId = this.activatedRoute.snapshot.params.blueprintId;
    if (blueprintId) {
      this.UpdateExtendService = true;
      this.blueprintsService.getBlueprintsIdLatestVersion(blueprintId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
        blueprintLatestVersion => {
          this.blueprintLatestVersion = blueprintLatestVersion;
          if (version) {
            this.latestSolutionVersion = version;
            this.missingCapabilities = this.blueprintLatestVersion?.capabilities
              .filter(item1 => !version.capabilities.some(item2 => item2.name === item1.name))
              .map(item => item.name);
    
            this.showMissingMsg = this.missingCapabilities?.length > 0;
    
            if (this.showMissingMsg) {
              setTimeout(() => {
                const title = translate('ERRORS.VALIDATION_ERROR');
                const message = translate('INSTANCE_DETAILS.SOLUTION_VERSION_MISMATCH');
                this.toastrService.errMessage(message, title);
              }, 500);
            }
              
          }
          this.capabilities.forEach(element => {
            this.blueprintLatestVersion?.capabilities?.forEach(capability => {
              if(element?.name === capability?.name) {
                element.showAdditional = true;
              }
            });
            if (element.nestedObj) {
              element.nestedObj.forEach(item => {
                if (this.blueprintLatestVersion.capabilities.find(capability => capability.name === item.name)) {
                  item.selected = true;
                  item.disabled = true;
                  if(element.componentType === ComponentType.EXCHANGE) {
                    const selected = element.nestedObj?.filter(item => item?.selected === true);
                    this.additionalExchangeAdapters = [...selected];
                    element.selectedNestedObj = element.nestedObj.filter(item => item.selected);
                  }
                  else if(element.required === CapabilityType.MANDATORY) {
                  const selected = element.nestedObj?.filter(item => item?.selected === true);
                  this.additionalIncluded = [...selected];
                  element.selectedNestedObj = element.nestedObj.filter(item => item.selected);
                  } else if(element.required === CapabilityType.OPTIONAL) {
                    const selected = element.nestedObj?.filter(item => item?.selected === true);
                    this.additionalOptional = [...selected];
                    element.selectedNestedObj = element.nestedObj.filter(item => item.selected);
                  }
                }
              })
            }
          })
         
          let capabilitiesByTypes;
          if(this.capabilities.find(item => item.componentType)) {
              capabilitiesByTypes = this.blueprintLatestVersion.capabilities
                .reduce((bluePrintacc, bluePrintCapability) => {
                  bluePrintacc = this.capabilities?.reduce((acc, capability) => {
                    if (capability.required === CapabilityType.OPTIONAL && bluePrintCapability.name === capability.name) {
                      capability.selected = true;
                      capability.disabled = true;
                      capability.showAdditional = true;
                    }
                    if(capability.componentType === ComponentType.EXCHANGE && bluePrintCapability.name === capability.name) {
                      capability.selected = true;
                      capability.disabled = true;
                      capability.showAdditional = true;
                    }
                    if(capability.componentType === ComponentType.EXCHANGE) {
                      let capabilitiesArr = acc[capability.componentType];
                      if (capabilitiesArr == null) {
                        capabilitiesArr = [];
                        acc[capability.componentType] = capabilitiesArr;
                      }
                      capabilitiesArr.push(capability);
                      return acc;
                    } else {
                      let capabilitiesArr = acc[capability.required];
                      if (capabilitiesArr == null) {
                        capabilitiesArr = [];
                        acc[capability.required] = capabilitiesArr;
                      }
                      if(capability.componentType === ComponentType.TBC || capability.componentType === ComponentType.TC) {
                        capabilitiesArr.push(capability);
                      }
                      return acc;
                    }
                  }, {});
                  if (bluePrintCapability.required === CapabilityType.OPTIONAL) {
                    this.selectedCapabilitiesLength.push(bluePrintCapability);
                  }
                  return bluePrintacc;
                }, {});
              } else {
                capabilitiesByTypes = this.blueprintLatestVersion.capabilities
                .reduce((bluePrintacc, bluePrintCapability) => {
                  bluePrintacc = this.capabilities?.reduce((acc, capability) => {
                    if (capability.required === CapabilityType.OPTIONAL && bluePrintCapability.name === capability.name) {
                      capability.selected = true;
                      capability.disabled = true;
                    }
                    let capabilitiesArr = acc[capability.required];
                    if (capabilitiesArr == null) {
                      capabilitiesArr = [];
                      acc[capability.required] = capabilitiesArr;
                    }
                    capabilitiesArr.push(capability);
                    return acc;
                  }, {});
                  if (bluePrintCapability.required === CapabilityType.OPTIONAL) {
                    this.selectedCapabilitiesLength.push(bluePrintCapability);
                  }
                  return bluePrintacc;
                }, {});
              }
              if (capabilitiesByTypes) {
                this.capabilitiesMapping(capabilitiesByTypes);
              }
              this.displayStartFreeTrialButton = true;
             }, (error) => {
                setTimeout(() => {
		              const title = translate('ERRORS.SERVICE_AVAILABILITY');
                  const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
                  this.toastrService.errMessage(message, title);
        }, 500);
            });
    
          this.blueprintsService.getBlueprint(blueprintId)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(blueprint => {
              this.isLoading = false;
              this.blueprint = blueprint;
              this.configureBreadcrumb(this.service);
              this.isDemoBlueprint = blueprint.demo;
              if (this.isDemoBlueprint) {
                // this.loadInstances();
              }
            });
        }
      }

      private capabilitiesMapping(capabilitiesByType?: any): any {
        this.capabilitiesGroups = Object.keys(capabilitiesByType)
          .map(capabilityType => ({name: capabilityType, capabilities: capabilitiesByType[capabilityType]}));
          this.additionalIncluded = [];
          this.capabilitiesGroups?.find(group => group.name === CapabilityType.MANDATORY)?.capabilities?.forEach((capability: any) => {
            if (capability?.selected === true && capability?.nestedObj) {
              const selected = capability?.nestedObj?.filter(item => item?.selected === true);
              this.additionalIncluded = [...this.additionalExchangeAdapters, ...selected];
            }
          });
        this.additionalOptional = [];
        this.selectedCapability = [];
        this.capabilitiesGroups?.find(group => group.name === CapabilityType.OPTIONAL)?.capabilities?.forEach((capability: any) => {
          if (capability?.selected === true) {
            this.selectedCapability?.push(capability);
            if(capability?.nestedObj) {
            const selected = capability?.nestedObj?.filter(item => item?.selected === true);
            this.additionalOptional = [...this.additionalOptional, ...selected];}
          }
        });
        this.additionalExchangeAdapters = [];
        this.selectedExchangeAdapters = [];
        this.capabilitiesGroups?.find(group => group.name === ComponentType.EXCHANGE)?.capabilities?.forEach((capability: any) => {
          if (capability?.selected === true) {
            this.selectedExchangeAdapters?.push(capability);
            if(capability?.nestedObj) {
            const selected = capability?.nestedObj?.filter(item => item?.selected === true);
            this.additionalExchangeAdapters = [...this.additionalExchangeAdapters, ...selected];
            }
          }
        });
        this.capabilitiesGroupsMandatory = this.capabilitiesGroups.find(item => item.name === CapabilityType.MANDATORY);
      }
    
      private configureBreadcrumb(service: Solution): void {
        this.breadcrumbItems = [];
        this.breadcrumbItems.push({label: translate('TENANT_LAYOUT.MENU.SERVICE_DEFINITION'), url:[RouterSegments.TENANT, this.activatedRoute.snapshot.params.id, RouterSegments.SERVICE_DEFINITION]},
        {label: this.blueprint?.name, url:[RouterSegments.TENANT, this.activatedRoute.snapshot.params.id, RouterSegments.SERVICE_DEFINITION, this.blueprint?.id]});
      }
      getSolutionById(solutionId): void {
        this.solutionsService.getSolutionById(solutionId)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(result => {
            this.isLoading = false;
            this.solution = result;
            if (this.getSelectedVersions) {
              this.getSelectedVersion(this.getSelectedVersions);
              this.selectedBuildVersion = this.getSelectedVersions;
              const version = this.versionData?.find(item =>item.version === this.getSelectedVersions.version);
              this.solutionVersionForm.get('buildVersion').setValue(version);
            }
          },
          (error) => {
            this.isLoading = false;
            setTimeout(() => {
              const title = translate('ERRORS.SERVICE_AVAILABILITY');
              const message = error?.message || error?.error?.message || error?.errmsg || translate('SERVICE.INTERNAL_SERVER_ERROR');
              this.toastrService.errMessage(message, title);
            }, 500);
          });
      }
      
      getLatestSolutionVersion(solutionId, latestSolutionVersionId): void {
        this.showLoader = true;
        this.solutionsService.getSolutionVersion(solutionId, latestSolutionVersionId)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe((version: any) => {
            this.showLoader = false;
            this.isLoading = false;
            this.loadData(version);
          }, (error) => {
            this.showLoader = false;
            this.isLoading = false;
            setTimeout(() => {
              const title = translate('NOTIFICATIONS.MISSING_CAPABILITIES_TITLE');
              const message = error?.message || error?.error?.message || error?.errmsg || translate('SERVICE.INTERNAL_SERVER_ERROR');
              this.toastrService.errMessage(message, title);
            }, 500);
          });
      }

      getSelectedVersion(event): void {
        this.selectedVersionExtend = event;
        this.versionSelected = true;
        this.getLatestSolutionVersion(event.solutionId, event.id);
      }

  goBack(): void {
    this.matDialog.open(ConfirmationDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      width: '566px',
      autoFocus: false,
      data: {
        title: translate('CREATE_SERVICE.CANCEL_UPDATE_TITLE'),
        message: translate('CREATE_SERVICE.CANCEL_UPDATE_MESSAGE'),
        confirmButtonText: translate('BUTTONS.CONFIRM')
      }
    })
      .afterClosed()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(confirm => {
        if (confirm) {
          this.router.navigate(['/', this.authService.principal.provider, RouterSegments.TENANT, this.activatedRoute.snapshot.params.id, RouterSegments.SERVICE_DEFINITION, this.blueprint?.id]);
        }
      });
  }

  selectCapability(capability): void {
    if (!capability?.disabled) {
      this.optionalCapabilities.find(item => item?.name === capability?.name).selected = !capability.selected;
      this.optionalCapabilities?.forEach(item => {
        if(item?.name === capability?.name && item?.selected === true) {
          capability.showAdditional = true;
          capability.selected = true;
        } else if(item?.name === capability?.name && item?.selected === false) {
          capability.selected = false;
          capability.showAdditional = false;
          capability.selectedNestedObj = [];  
          item?.nestedObj?.forEach(nestedData => {
            this.additionalOptional = this.additionalOptional.filter(data => data.name !== nestedData.name)
            nestedData.selected = false;
          })
        }
      });
      this.selectedCapability = this.optionalCapabilities?.filter(item => item?.selected === true);
    }
  }

  selectExchangeAdapter(capability): void {
    if (!capability?.disabled) {
    this.exchangeAdapters.find(item => item?.name === capability?.name).selected = !capability.selected;
    this.exchangeAdapters?.forEach(item => {
      if(item?.name === capability?.name && item?.selected === true) {
        capability.showAdditional = true;
        capability.selected = true;
      } else if(item?.name === capability?.name && item?.selected === false) {
        capability.selected = false;
        capability.showAdditional = false;
        capability.selectedNestedObj = []; 
        item?.nestedObj?.forEach(nestedData => {
          this.additionalExchangeAdapters = this.additionalExchangeAdapters.filter(data => data.name !== nestedData.name)
          nestedData.selected = false;
        })
      }
    });
    this.selectedExchangeAdapters = this.exchangeAdapters?.filter(item => item?.selected === true);
    }
  }

  selectionChanged(changedCapability: Capability): void {
    const selectedCapabilities = [];
    selectedCapabilities.push(changedCapability);
    this.toastrService.clear();
    const name = changedCapability?.displayName ? changedCapability?.displayName : changedCapability?.name;
    setTimeout(() => {
      const formattedName = name[0].toUpperCase() + name.substring(1).toLowerCase();
      const action = changedCapability?.selected ? translate('TENANT_LAYOUT.SERVICE_DEFINITION.ADDED') : translate('TENANT_LAYOUT.SERVICE_DEFINITION.REMOVED');
      const message = `${formattedName} ${action}`;
      const title = translate('INSTANCE_SUMMARY.SERVICE_DEFINITION.SELECTED_CAPABILITIES');
      this.toastrService.successMessage(message, title);
    }, 500);

    if (!this.activatedRoute.snapshot.params.blueprintId) {
      this.UpdateExtendService = false;
      this.UpdateExtendServiceDisable = false;
    } else {
      this.UpdateExtendService = true;
      this.UpdateExtendServiceDisable = true;
    }

    selectedCapabilities.reduce(
      (acc, capability, c) => {
        if (capability.selected === true && capability.required === CapabilityType.OPTIONAL) {
          this.selectedCapabilitiesArr.push(capability);
        } else {
          this.selectedCapabilitiesArr
            .reduce((cap, falseCapability) => {
              if (falseCapability.selected === false) {
                this.selectedCapabilitiesArr = this.selectedCapabilitiesArr.filter((x) => {
                  if (x.selected === true && x.required === CapabilityType.OPTIONAL) {
                    return x.selected === true;
                  }
                });
              }
              return cap;
            }, {});
        }
        return acc;
      }, {}
    );
  }

  resetSelection(): void {
    if (this.selectedCapabilitiesArr?.length > 0) {
      setTimeout(() => {
          const message = translate('INSTANCE_SUMMARY.SERVICE_DEFINITION.SELECTED_CAPABILITIES_REMOVED');
            const title = translate('INSTANCE_SUMMARY.SERVICE_DEFINITION.SELECTED_CAPABILITIES');
            this.toastrService.successMessage(message, title);
        }, 500);
      this.selectedCapabilitiesArr = [];
    }
    this.capabilitiesGroups?.find(group => group.name === CapabilityType.OPTIONAL)?.capabilities?.forEach((capability: any) => {
      if (capability?.selected === true && capability?.disabled !== true) {
        capability.selected = false;
        capability.showAdditional = false;
        this.additionalOptional = capability?.selectedNestedObj ? capability?.selectedNestedObj?.filter(item => item.disabled === true) : this.additionalOptional;
        const capabilityAvailable: any = this.capabilitiesGroups.filter((item: any) => item.name === 'optional');
        this.selectedCapability = capabilityAvailable[0].capabilities.filter(item => item.disabled === true);
        capability?.nestedObj?.forEach(item => {
          if(!item.disabled) {
            item.selected = false;
          }
        })
        capability.selectedNestedObj = capability?.selectedNestedObj?.filter(item => item.disabled === true);
      } else if(capability?.selected === true && capability?.disabled === true) {
        this.additionalOptional = capability?.selectedNestedObj ? capability?.selectedNestedObj?.filter(item => item.disabled === true) : this.additionalOptional;
        const capabilityAvailable: any = this.capabilitiesGroups.filter((item: any) => item.name === 'optional');
        this.selectedCapability = capabilityAvailable[0].capabilities.filter(item => item.disabled === true);
        capability?.nestedObj?.forEach(item => {
          if(!item.disabled) {
            item.selected = false;
          }
        })
        capability.selectedNestedObj = capability?.selectedNestedObj?.filter(item => item.disabled === true);
      }
    });
  }

  resetExchangeSelection(): void {
    if (this.selectedCapabilitiesArr?.length > 0) {
      setTimeout(() => {
          const message = translate('INSTANCE_SUMMARY.SERVICE_DEFINITION.SELECTED_CAPABILITIES_REMOVED');
            const title = translate('INSTANCE_SUMMARY.SERVICE_DEFINITION.SELECTED_CAPABILITIES');
            this.toastrService.successMessage(message, title);
        }, 500);
      this.selectedCapabilitiesArr = [];
    }
    this.capabilitiesGroups?.find(group => group.name === ComponentType.EXCHANGE)?.capabilities?.forEach((capability: any) => {
      if (capability?.selected === true && capability?.disabled !== true) {
        capability.selected = false;
        capability.showAdditional = false;
        this.additionalOptional = capability?.selectedNestedObj ? capability?.selectedNestedObj?.filter(item => item.disabled === true) : this.additionalOptional;
        const capabilityAvailable: any = this.capabilitiesGroups.filter((item: any) => item.name === ComponentType.EXCHANGE);
        this.selectedExchangeAdapters = capabilityAvailable[0].capabilities.filter(item => item.disabled === true);
        capability?.nestedObj?.forEach(item => {
          if(!item.disabled) {
            item.selected = false;
          }
        })
        capability.selectedNestedObj = capability?.selectedNestedObj?.filter(item => item.disabled === true);
      } else if(capability?.selected === true && capability?.disabled === true) {
        const capabilityAvailable: any = this.capabilitiesGroups.filter((item: any) => item.name === ComponentType.EXCHANGE);
        this.selectedExchangeAdapters = capabilityAvailable[0].capabilities.filter(item => item.disabled === true);
        this.additionalOptional = capability?.selectedNestedObj ? capability?.selectedNestedObj?.filter(item => item.disabled === true) : this.additionalOptional;
        capability?.nestedObj?.forEach(item => {
          if(!item.disabled) {
            item.selected = false;
          }
        })
        capability.selectedNestedObj = capability?.selectedNestedObj?.filter(item => item.disabled === true);
      }
    });
  }

  titleCaseWord(word): any {
    if (!word) {
      return word;
    }
    return word[0].toUpperCase() + word.substr(1).toLowerCase();
  }

  isUpdated(capability): boolean {
    if (this.selectedCapabilities) {
      return this.selectedCapabilities.some(e => e.name === capability.name);
    }
  }

  
  getInstanceStatus(instance: Instance): void {
    const currentDate = +new Date();
    const instanceCreatedDate = new Date(instance.dateCreated);
    const maximumLoadingTime = instanceCreatedDate.setMinutes(instanceCreatedDate.getMinutes() + 5);
    if (currentDate > maximumLoadingTime && instance.status === DeployStatus.DEPLOYED) {
      this.instanceStatus = DeployStatus.DEPLOYED;
    } else {
      this.instanceStatus = DeployStatus.DEPLOYING;
    }
  }

  onUpdateSandbox(): void {
    let deployment;
    const getSelectedCapabilities = [];
    const blueprint = {
      solutionId: this.service.id,
      name: this.service.name,
      demo: 'true'
    } as any;

    if (this.capabilities && this.capabilities.length > 0) {
      this.capabilities.filter((x) => {
        if (x.selected) {
          getSelectedCapabilities.push(x.name);
        }
      });
    }

    this.demoInstance = {
      status: DeployStatus.DEPLOYING
    } as Instance;

    const blueprintIds = this.activatedRoute.snapshot.params.blueprintId;

    this.blueprintsService.createBlueprintVersion(blueprintIds, getSelectedCapabilities)
      .pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (blueprintVersion: any) => {
        deployment = {
          blueprintId: blueprintIds,
          blueprintVersionId: blueprintVersion.id,
          region: this.service.regionalAvailability[0],
          dataZone: DataZone.DEVELOPMENT,
          deploymentClass: DeploymentClass.D,
          name: translate('BLUEPRINT_SUMMARY.DEMO_INSTANCE_SANDBOX'),
          capabilities: getSelectedCapabilities
        } as Deployment;
        this.instancesService.applyDefinition(blueprintVersion.id, this.instanceId)
          .pipe(takeUntilDestroyed(this.destroyRef)).subscribe((deploymentINs) => {
          this.router.navigate(['/', this.authService.principal.provider, RouterSegments.SERVICES, this.service.id,
            RouterSegments.BLUEPRINTS, blueprintIds]);
        }, (error) => {
          this.deployInstanceError(error);
          // Remove demoInstance if deployment fail to avoid disabling the button.
          delete this.demoInstance;
        });
      }, (error) => {
        this.deployInstanceError(error);
        // Remove demoInstance if deployment fail to avoid disabling the button.
        delete this.demoInstance;
      });

  }

  deployInstanceError(error): void {
    this.sandboxLoader = false;
    const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
    this.matDialog.open(ErrorDialogComponent, {
      minHeight: '342px',
      width: '566px',
      panelClass: 'flex-dialog',
      data: {
        title: translate('NOTIFICATIONS.SANDBOX_FAILED'),
        description: errorMessage,
      }
    });
  }

  continue(): void {
    if (this.removeExchangeTab) {
      this.updateService();
    } else {
      this.capabilitiesPage = false;
    }
  }
 
  previousCapabilityPage(): void {
    this.capabilitiesPage = true;
  }

  navigateToSolution(id): void {
    this.router.navigate(['/',this.authService.principal.provider, 'tenant', this.tenant,RouterSegments.SOLUTION, id, 'versions']);
  }

  searchChanged(value): void {
    this.versionData = this.versionsList;
  }

  resetFilter(): void {
    this.solutionVersionForm.get('searchValue').reset();
    this.versionData = this.versionsList;
    if(this.versionData.length === 0) {
      const noRelease = 'Release not Available';
      this.versionData.push(noRelease);
   }
}

  onOptionsSelected(data){
    this.versionData = this.versionsList.filter(item => item?.releaseVersion?.includes(data.value));
  }

  dropdownClose(): void {
    if (this.versionData?.length === 0) {
      this.versionData = this.versionsList;
    }
  }

  versionGroup(versions) {
    let group = [];
    this.versionsList = versions;
    this.versionsList.forEach(item => {
      group.push(item?.version?.split('.')[0]);
    });
    group = [...new Set(group)];

    let makeGrouping = [];
    group.forEach(groupItem => {
      const versions: any = this.versionsList.filter(item => item?.version?.split('.')[0] === groupItem);
      const groupName = {version: groupItem, group: true, releaseVersion: (versions[0]?.releaseVersion.split('.')[0].split('').length > 2 ? versions[0]?.releaseVersion.split('.')[0] : 'R'+versions[0]?.releaseVersion.split('.')[0])};
      versions.push(groupName);      
      makeGrouping.push(versions);
    });

    const combineData = makeGrouping.flat();
    const finalData = combineData.sort((a, b) => { 
      if (a.version < b.version) return -1;
      if (a.version > b.version) return 1;
    })

    this.versionsList = finalData;
    this.versionData = finalData;
  }

  viewClick(): void {
    this.matDialog.open(ErrorDialogComponent, {
      minHeight: '342px',
      width: '566px',
      panelClass: 'flex-dialog',
      data: {
        title: translate('NOTIFICATIONS.MISSING_CAPABILITIES_TITLE'),
        newDescription: translate('NOTIFICATIONS.MISSING_CAPABILITIES'),
        description: JSON.stringify(this.missingCapabilities),
      }
    });
  }  
}